export enum TenantStrategyEnum {
  stratusOrganization = 'stratusOrganization',
  stratusCustomer = 'stratusCustomer',
  stratusNative = 'stratusNative',
  onecloudOrganization = 'onecloudOrganization'
}
